module.exports = __webpack_public_path__ + "assets/de8840301724f1f4dcc9edeb6c1a2664.png";